import {
  requestCardTypeList,
  requestCompanyCardTypeList,
} from '@/api/cardType';

const state = {
  cardTypeList: null,
  companyCardTypeList: null,
};

const getters = {
  cardTypeList: (state) => state.cardTypeList,
  companyCardTypeList: (state) => state.companyCardTypeList,
};

const actions = {
  async setCardTypeList({ commit, dispatch }) {
    await dispatch('setIsLoading', true, { root: true });
    const result = await requestCardTypeList();
    commit('setCardTypeList', result);
    await dispatch('setIsLoading', false, { root: true });
  },

  async setCompanyCardTypeList({ commit, dispatch }) {
    try {
      dispatch('setIsLoading', true, { root: true });
      const result = await requestCompanyCardTypeList();
      if (result.data && !result.data.errors) {
        commit('setCompanyCardTypeList', result.data);
      } else {
        console.error('企業カードタイプの取得に失敗しました:', result.data.errors);
      }
      dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    } catch (error) {
      console.error('企業カードタイプの取得でエラーが発生しました:', error);
    } finally {
      dispatch('setIsLoading', false, { root: true });
    }
  },
};

const mutations = {
  setCardTypeList(state, cardTypeList) {
    state.cardTypeList = cardTypeList.data.list;
  },

  setCompanyCardTypeList(state, data) {
    state.companyCardTypeList = data.list;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
